import { directionOutcomes, siteCopy } from "../../content";
import type { Recommendation } from "../../app/experience-state";
import styles from "./JournalLanding.module.css";

const copy = siteCopy.journal;

type JournalLandingProps = {
  recommendation?: Recommendation;
  onDrawCard: () => void;
  onStartSoulCheck: () => void;
};

export function JournalLanding({
  recommendation,
  onDrawCard,
  onStartSoulCheck,
}: JournalLandingProps) {
  return (
    <div className={styles.landing}>
      {recommendation ? (
        <p className={styles.returnNote}>
          {copy.returnNoteBefore}{" "}
          <strong>{directionOutcomes[recommendation].label}</strong>.{" "}
          {copy.returnNoteAfter}
        </p>
      ) : null}

      <div className={styles.routes}>
        <button className={styles.route} type="button" onClick={onDrawCard}>
          <span className={styles.symbol} aria-hidden="true">✦</span>
          <span>
            <strong>{copy.cardRouteTitle}</strong>
            <small>{copy.cardRouteDetail}</small>
          </span>
          <span className={styles.arrow} aria-hidden="true">→</span>
        </button>

        <button className={styles.route} type="button" onClick={onStartSoulCheck}>
          <span className={styles.symbol} aria-hidden="true">≈</span>
          <span>
            <strong>{copy.soulCheckRouteTitle}</strong>
            <small>{copy.soulCheckRouteDetail}</small>
          </span>
          <span className={styles.arrow} aria-hidden="true">→</span>
        </button>
      </div>

      <p className={styles.privacy}>{copy.privacyNote}</p>
    </div>
  );
}
